<template>
  <div class="percent-indicator">
    <q-icon
      :name="icon"
      :class="colorClass"
      size="20px"
    />
    <span :class="colorClass">
      {{ Math.abs(Math.round(percentChange)) }}%
    </span>
    <span v-if="appendText" :class="colorClass">
      {{ appendText }}
    </span>
  </div>
</template>

<script>
export default {
  name: "PercentChangeIndicator",
  props: {
    percentChange: {
      type: Number,
      required: true
    },
    appendText: {
      type: String,
      default: ""
    }
  },
  computed: {
    icon() {
      if (this.percentChange === 0) {
        return "sym_r_trending_flat";
      }
      return this.percentChange > 0
        ? "sym_r_trending_up"
        : "sym_r_trending_down";
    },
    colorClass() {
      if (this.percentChange === 0) {
        return "text-text-light";
      }
      return this.percentChange > 0 ? "text-positive" : "text-negative";
    }
  }
};
</script>

<style lang="scss" scoped>
.percent-indicator {
  display: flex;
  align-items: center;
  gap: 4px;
}
</style>
